var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrashOutlineWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.5H8V15H9.25V7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5H11.75V15H13V7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3.75V5H4.25V17.5C4.25 17.8315 4.3817 18.1495 4.61612 18.3839C4.85054 18.6183 5.16848 18.75 5.5 18.75H15.5C15.8315 18.75 16.1495 18.6183 16.3839 18.3839C16.6183 18.1495 16.75 17.8315 16.75 17.5V5H18V3.75H3ZM5.5 17.5V5H15.5V17.5H5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1.25H8V2.5H13V1.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrashOutlineWhite);
export default __webpack_public_path__ + "static/media/ic-trash-outline-white.f65e6a5ef71447a59bbee97080492daa.svg";
export { ForwardRef as ReactComponent };